import React from 'react'
import { motion } from "framer-motion";
import NavigationButton from './NavigationButton';

const MainImage = () => {
  return (
    <motion.div initial={{ opacity: 0}} whileInView={{ opacity: 1}}  transition={{ delay: 0.2, duration: 2}} >
          <section id="main-image" className="section-image-bg">
              <div className="row section-full-frame section-diviser">
                  <div className="col-sm-12 d-flex flex-column justify-content-between align-items-center">
                      <NavigationButton mySelector="#intro" myIcon="chevron-up" hasMargin={false}/>
                      <NavigationButton mySelector="#right-image" myIcon="chevron-down" hasMargin={true}/>
                  </div>
              </div> 
          </section>
        </motion.div>
  )
}

export default MainImage